import { render, staticRenderFns } from "./AddMessageTemplates.vue?vue&type=template&id=679382bc"
import script from "./AddMessageTemplates.vue?vue&type=script&lang=js"
export * from "./AddMessageTemplates.vue?vue&type=script&lang=js"
import style0 from "./AddMessageTemplates.vue?vue&type=style&index=0&id=679382bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports